export default "__VITE_ASSET__2ErWQ_8g__"